import { parsePhoneNumber } from "awesome-phonenumber";
import { isValidEmail } from "./emailValidation";

export const MOBILE_ERROR =
  "Please enter a valid mobile number (e.g. 0917 123 4567).";
export const EMAIL_ERROR = "Please enter a valid email address.";

const INVALID_MOBILE = { valid: false, e164: null, display: null };

/**
 * Same rule as the api's walk-in join (`util.parsePhoneNumber`): a valid
 * *mobile* number under the "PH" hint, so local formats (0917…, 917…) parse
 * and foreign mobiles typed with their country code are accepted too.
 *
 * @param {string} value what the guest typed
 * @returns {{valid: boolean, e164: string | null, display: string | null}}
 */
export const parseWalkInMobile = (value) => {
  if (typeof value !== "string" || !value.trim()) return INVALID_MOBILE;

  const parsed = parsePhoneNumber(value.trim(), "PH");
  if (!parsed.isValid() || !parsed.isMobile()) return INVALID_MOBILE;

  return {
    valid: true,
    e164: parsed.getNumber("e164"),
    display: parsed.getNumber("international"),
  };
};

export const isValidWalkInEmail = (value) =>
  typeof value === "string" && isValidEmail(value.trim());

/**
 * Field errors for the walk-in join form. Empty fields are skipped on
 * purpose: the form's own required-field check owns "This field is required".
 */
export const validateWalkInDetails = (values = {}) => {
  const errors = {};

  if (values.mobileNumber && !parseWalkInMobile(values.mobileNumber).valid) {
    errors.mobileNumber = MOBILE_ERROR;
  }
  if (values.email && !isValidWalkInEmail(values.email)) {
    errors.email = EMAIL_ERROR;
  }

  return errors;
};

/**
 * Renders a stored E.164 number the way the guest would type it: local format
 * for PH numbers, international otherwise. Anything unparseable is returned
 * as-is so the guest can see (and fix) it.
 */
export const formatWalkInMobileForInput = (value) => {
  if (typeof value !== "string" || !value) return "";

  const parsed = parsePhoneNumber(value, "PH");
  if (!parsed.isValid()) return value;

  return parsed.getRegionCode() === "PH"
    ? parsed.getNumber("national")
    : parsed.getNumber("international");
};
